import { useCallback, useState } from 'react';

import { useClientConfirmationData } from 'modules/onboarding/common/hooks';

import { useOnboardingContext } from './useOnboardingContext';

export const useConfirmationData = () => {
  const { goToBack, clientId, goToNext } = useOnboardingContext();

  const { confirm, error } = useClientConfirmationData(clientId);

  const [loading, setLoading] = useState(false);

  const onConfirm = useCallback(async () => {
    setLoading(true);
    try {
      await confirm();
      setTimeout(goToNext, 300);
    } catch (error) {
      setLoading(false);
    }
  }, [confirm, goToNext]);

  return { onConfirm, goToBack, loading, error };
};
